import { render, staticRenderFns } from "./XhDialog.vue?vue&type=template&id=c24200c2&scoped=true&"
import script from "./XhDialog.vue?vue&type=script&lang=js&"
export * from "./XhDialog.vue?vue&type=script&lang=js&"
import style0 from "./XhDialog.vue?vue&type=style&index=0&id=c24200c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24200c2",
  null
  
)

export default component.exports